import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const dropdownMenuLabel = tailwindVariants({
  base: 'pt-2 font-bold text-10 text-gray-10 uppercase tracking-wide',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'px-2',
      small: 'px-1.5',
    },
  },
});

export type DropdownMenuLabelVariants = VariantProps<typeof dropdownMenuLabel>;

export type DropdownMenuLabelProps = Omit<RadixDropdownMenu.DropdownMenuLabelProps, 'size'> & DropdownMenuLabelVariants;

export const DropdownMenuLabel = memo(({ className, size = 'small', ...restOfProps }: DropdownMenuLabelProps) => {
  return (
    <RadixDropdownMenu.Label
      className={dropdownMenuLabel({ className, size })}
      data-testid="DROPDOWN_MENU_LABEL"
      {...restOfProps}
    />
  );
});

DropdownMenuLabel.displayName = 'DropdownMenuLabel';
